import React from 'react';
import icon1 from './../../assets/tick2.svg'
import '././../../pages/notifications.css'
const Notification = (props) => {
    return ( <>
    <div className="notifFlex">
            <div className='notifFlex1'>
<div className="imgcont">
    <img src={icon1} alt="" />
</div>
                <div className='div'>
                <h5>
                    Booking confirmed!
                </h5>
                <h6>2 hours ago</h6>
            </div>

            </div>
            
            <span></span>
            
        </div>
    </> );
}
 
export default Notification;